"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const EdgeRounded = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 12,
  height: 12,
  viewBox: "3 3 19 19"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.661 6a3 3 0 10-6 0 3 3 0 006 0zm-12 12a3 3 0 10-6 0 3 3 0 006 0z",
  fill: "#BBC4CD",
  className: "fill"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M6.661 18v-6h12V6",
  stroke: "#BBC4CD",
  strokeWidth: "2",
  strokeLinejoin: "round",
  fill: "none",
  className: "stroke"
}));

var _default = EdgeRounded;
exports.default = _default;